import React, { useState } from 'react';
import IconSearch from '@static/images/icon_search.svg';
import IconX from '@static/images/icon_x.svg';
import { IconButton } from '@colonist/ui';
import { PlayerFilterDialog } from './PlayerFilterDialog.tsx';
/** Icon button that opens a PlayerFilterDialog for filtering the leaderboard by player name. */ export const PlayerFilterDialogButton = ({ onSearch, searchedValue })=>{
    const [isOpen, setIsOpen] = useState(false);
    const hasActiveSearch = searchedValue != undefined && searchedValue != '';
    if (hasActiveSearch) {
        return /*#__PURE__*/ React.createElement(IconButton, {
            icon: IconX,
            alt: "strings:popups.searchPlayer.clearButton",
            onClick: ()=>onSearch('')
        });
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(IconButton, {
        icon: IconSearch,
        alt: "strings:popups.searchPlayer.title",
        inverted: true,
        onClick: ()=>setIsOpen(true)
    }), /*#__PURE__*/ React.createElement(PlayerFilterDialog, {
        open: isOpen,
        onClose: ()=>setIsOpen(false),
        onSearch: onSearch
    }));
};
